<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vx-card>
      <vs-collapse align="right">
        <vs-collapse-item>
          <div slot="header">
            <feather-icon class="mr-2" icon="InfoIcon" svgClasses="h-5 w-5" />
          </div>
          <p>Criado por {{ userNameCreate }} às {{ createAt }}</p>
          <p>Modificado por {{ userNameModified }} às {{ modifiedAt }}</p>
        </vs-collapse-item>
      </vs-collapse>
      <div class="vx-row">
        <div class="vx-col md:w-1/6 w-full mt-5">
          <h6 class="mb-2">Data</h6>
          <div>
            <datepicker
              placeholder="Selecione a Data"
              :language="languages['ptBR']"
              format="dd/MM/yyyy"
              v-model="date"
            ></datepicker>
          </div>
        </div>
        <div class="vx-col md:w-1/2 mt-5">
          <h6 class="mb-2">Cliente</h6>
          <v-select
            name="customer"
            v-model="customerSelected"
            :options="getCustomersFiltered"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="'required'"
            disabled
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-1/3 mt-5">
          <h6 class="mb-2">Nome do Técnico</h6>
         <v-select
              name="user"
              v-model="userSelected"
              :options="getUsers"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-validate="'required'"
            />
         <span class="text-danger">{{ errors.first("user") }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-1/3 mt-5">
          <h6 class="mb-2">Observação</h6>
          <vs-input name="recipient2" v-model="obs" class="w-full" />
          <br />
        </div>
        <div class="vx-col md:w-1/3 w-1/3 mt-5">
          <h6 class="mb-2">Destino</h6>
          <v-select
            name="destiny"
            v-model="destiny"
            :options="destinyList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="'required'"
          />
          <span class="text-danger">{{ errors.first("destiny") }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-1/2 mt-5">
          <h6 class="mb-2">Produto</h6>
          <v-select
            :options="getProducts"
            name="product"
            label="label"
            v-model="product"
          >
            <template slot="option" slot-scope="option">
              <img
                :src="option.image"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              {{ option.label }}
            </template>
          </v-select>
          <span class="text-danger">{{ errors.first("product") }}</span>
        </div>
         <div class="vx-col md:w-1/4 w-1/4 mt-5">
          <h6 class="mb-2">Quantidade</h6>
          <vs-input-number v-model="amount" />
          <br />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-full mt-5">
          <vs-button
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            @click="addItem"
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-between
              bg-primary
            "
            >Adicionar</vs-button
          >
        </div>
      </div>
      <vue-good-table
        ref="my-table"
        selectionInfoClass="mytable"
        style="width: 100%"
        styleClass="vgt-table condensed"
        :search-options="{
          enabled: true,
          trigger: '',
          placeholder: 'Procurar',
          skipDiacritics: true,
        }"
        :pagination-options="paginationOptions"
        :columns="columns"
        :rows="items"
        @on-row-click="onRowClick"
      >
        <div slot="emptystate" class="text-center">
          Nenhum resultado encontrado
        </div>
        <template slot="table-row" slot-scope="item">
          <span class="font-medium" v-if="item.column.field == 'idProduct'">
            <vs-chip color="success">{{ item.row.idProduct }}</vs-chip>
          </span>
          <span class="font-medium" v-if="item.column.field == 'name'">
            {{ item.row.name }}
          </span>
          <span class="font-medium" v-if="item.column.field == 'amount'">
            {{ item.row.amount }}
          </span>
          <span class="font-medium" v-if="item.column.field == 'action'">
            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="deleteItem(item.row.originalIndex)"
            ></vs-button>
          </span>
        </template>
      </vue-good-table>
      <div class="vx-row">
        <div class="vx-col md:w-full mt-5">
          <vs-button
            type="filled"
            icon-pack="feather"
            icon="icon-save"
            @click="submit"
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-between
              bg-success
            "
            >Salvar</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>


<script>
import { Validator } from "vee-validate";
import axios from "axios";
import { baseApiUrl } from "@/global";
import router from "@/router";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { momentJS } from "@/helpers";
import { VueGoodTable } from "vue-good-table";
const dict = {
  custom: {
    user: {
      required: "Selecione o Técnico",
    },
    customer: {
      required: "Selecione o Cliente",
    },
    destiny: {
      required: "Selecione o Destino",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: {
    "v-select": vSelect,
    Datepicker,
    VueGoodTable,
  },
  data() {
    return {
      idPartsRequest: null,
      date: null,
      languages: lang,
      customerSelected: {
        id: "1159",
        label: "COPYJUI SOLUCOES DIGITAIS LTDA",
      },
      technicianList: [
        "Carlos Silva",
        "Dion Diesel",
        "Eder Escobar",
        "João Paulo",
        "Maicon Escobar",
        "Rogério Pohlmann",
        "Vitor Nassarden",
      ],
      product: null,
      obs: null,
      destiny: null,
      destinyList: ["Copyjui", "Cliente"],
      createAt: null,
      modifiedAt: null,
      amount: 1,
      userNameCreate: null,
      userNameModified: null,
      userSelected: null,
      momentJS: null,
      items: [],
      paginationOptions: {
        enabled: true,
        nextLabel: "Próxima",
        prevLabel: "Anterior",
        rowsPerPageLabel: "Resultados por página",
        ofLabel: "de",
        pageLabel: "Página",
        allLabel: "Todos",
        mode: "pages",
        perPage: 50,
      },
    };
  },
  computed: {
     getUsers() {
      return this.$store.state.usersFiltered;
    },
    getProducts() {
      let products = _.cloneDeep(this.$store.state.products);
      products.forEach((element) => {
        element.id = element.idProduct;
        element.label = `${element.name} | ${element.code}`;
        element.image = element.photoProduct;
      });
      return products;
    },
    getCustomersFiltered() {
      let customers = _.cloneDeep(
        this.$store.state.customers.customersFiltered
      );
      customers.forEach((element) => {
        element.id = element.id;
        element.label = `${element.idIlux} | ${element.corporateName}`;
        element.mail = element.mail;
        element.mail2 = element.mail2;
      });
      return customers;
    },
  },
  methods: {
     onRowClick(params) {
      // Somente para ter a mão do mouse clique
    },
    async addItem() {
      let product = {
        idProduct: this.product.idProduct,
        name: this.product.name,
        amount: this.amount,
      };
      this.items.push(product);
      this.product = [];
      this.amount = 1;
    },
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    mountTable() {
      this.columns = [
        {
          label: "Código",
          field: "idProduct",
          tdClass: "align-middle",
        },
        {
          label: "Produto",
          field: "name",
          tdClass: "align-middle",
        },
        {
          label: "Quantidade",
          field: "amount",
          tdClass: "align-middle",
        },
         {
          label: "Ação",
          field: "action",
          tdClass: "align-middle",
        },
      ];
    },
    async submit() {
      const haveErrors = !(await this.$validator.validateAll());
      if (haveErrors) return;
      delete this.items.name;
      let data = {
        idPartsRequest: this.idPartsRequest,
        date: this.date,
        destiny: this.destiny,
        obs: this.obs,
        items: this.items,
        modifiedAt: momentJS().getDateTime(),
        fk_idCustomer: this.customerSelected.id,
        modifiedBy: this.$store.state.user.idUser,
      };
      try {
        this.$vs.loading();
        await axios.post(`${baseApiUrl}/partsRequest/update`, data);
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        router.push("/solicitacao").catch(() => {});
      } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
        this.items = [];
      }
    },
  },
  async created() {
    this.mountTable();
    this.momentJS = momentJS();
    let payload = {
      loading: this.$vs.loading,
    };
    try {
      const response = await axios.get(
        `${baseApiUrl}/partsRequest/getPartsRequestById/${this.$route.params.idPartsRequest}`
      );
      let partsRequest = response.data.partsRequest[0];
      this.idPartsRequest = partsRequest.idPartsRequest;
      this.date = partsRequest.date;
      this.destiny = partsRequest.destiny;
      this.obs = partsRequest.obs;
      this.createAt = this.momentJS.formatDateTimeForPTBR(
        partsRequest.createAt
      );
      this.modifiedAt = this.momentJS.formatDateTimeForPTBR(
        partsRequest.modifiedAt
      );
      this.userNameCreate = partsRequest.userNameCreate;
      this.userNameModified = partsRequest.userNameModified;
      let user = {
        id:partsRequest.idUser,
        label:partsRequest.userName,
        name: partsRequest.userName,
      };
      this.userSelected = user;
      this.items = response.data.items;
      this.$vs.loading.close();
    } catch (error) {
      if (!error.response || !error.response.data) return;
      this.$vs.notify({
        title: "Ocorreu algum problema",
        text: error.response.data,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
    } finally {
      this.$vs.loading.close();
    }
     this.$store.dispatch("fetchAllUsers", payload);
    this.$store.dispatch("fetchProductsItems", payload);
    this.$store.dispatch("customers/fetchCustomersItems", payload);
  },
};
</script>
 
